/**
 * 이 파일은 Aui 의 일부입니다. (https://aui.moimz.tools)
 *
 * 외부에 노출되는 Utils 통합 인덱스를 정의한다.
 *
 * @file /src/namespaces/Utils.ts
 * @author Arzz <arzz@arzz.com>
 * @license MIT License
 * @modified 2026. 4. 17.
 */
import { Utils as UtilsBase } from '@utils/Utils';
import { Format as FormatBase } from '@utils/Format';
import { Html as HtmlBase } from '@utils/Html';
import { Ajax as AjaxBase } from '@utils/Ajax';
import { Language as LanguageBase } from '@utils/Language';

export class Utils extends UtilsBase {}
export namespace Utils {
    export const Format = FormatBase;
    export const Html = HtmlBase;
    export const Ajax = AjaxBase;
    export const Language = LanguageBase;
}
